import useSavePushNotificationTokeniOS from "services/firebase/messaging-ios/hooks/useSavePushNotificationToken";

import { useSetAndroidTWA } from "features/pwa/mobile/android/hooks/useAndroidTWA";

import SmartAppBanner from "./ios/components/SmartAppBanner";
import useSendRegionMessageiOS from "./ios/hooks/useSendRegionMessage";

type Props = {
  children: React.ReactElement;
};

export default function PWAMobileProvider({ children }: Props) {
  useSetAndroidTWA();
  useSendRegionMessageiOS();
  useSavePushNotificationTokeniOS();

  return (
    <>
      <SmartAppBanner />
      {children}
    </>
  );
}
